// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 20V2H2V22H22V20H20V16.5H14V20H12V16.5H6V20H4Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 14.5H12V9H6V14.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14 14.5H20V5H14V14.5Z"}}]};

const ChartStackedFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chart-stacked-filled',
    ref,
    icon: element,
  },
));

ChartStackedFilledIcon.displayName = 'ChartStackedFilledIcon';

export default ChartStackedFilledIcon;
